export default {
  Request_URL: "https://api.ydxxt.vip", //http://192.168.0.110:8880/api  //https://api.ydxxt.vip
};
